<template>
<div class="page home-page">
	<video id="bgvid"
		playsinline autoplay muted
	>
		<source src="../assets/videos/format_video_2.mp4" type="video/mp4">
	</video>
	<h1 class="background-text">
		<span>Seeing </span>
		<span>the</span><br>
		<span>Investment </span>
		<span>landscape</span>
	</h1>
	<navbar />
	<main-sidebar />
	<statistic-bar />
</div>
</template>

<script>
import Navbar from '@/components/main/Navbar'
import MainSidebar from '@/components/main/MainSidebar'
import StatisticBar from '@/components/main/StatisticBar'
import { runStatisticAnimation } from '@/utils/helpers'

export default {
	components: {
		Navbar,
		MainSidebar,
		StatisticBar
	},
	mounted() {
		runStatisticAnimation()
	}
}
</script>

<style lang="scss">
video { 
	position: fixed;
	top: 50%;
	left: 50%;
	min-width: 100%;
	min-height: 100%;
	width: auto;
	height: auto;
	z-index: -100;
	transform: translateX(-50%) translateY(-50%);
	background-size: cover;
	transition: 1s opacity;
}

.navbar {
	opacity: 0;
	animation: fadeIn 2s linear 2s forwards;
}
.main-sidebar {
	opacity: 0;
	animation: fadeIn 2s linear 3s forwards;
}
.home-page {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;

	.background-text {
		text-align: left;
		color: #fff;
		position: absolute;
		bottom: 22%;
		left: 3%;
		font-size: 55px;
		font-weight: 600;
		text-transform: uppercase;
		width: 360px;
		letter-spacing: 1px;
		user-select: none;

		span {
			opacity: 0;
		}

		span:nth-child(1) {
			animation: fadeIn 2s linear 5s forwards, fadeOut 3s linear 28s forwards;
		}
		span:nth-child(2) {
			animation: fadeIn 2s linear 7s forwards, fadeOut 3s linear 28s forwards;
		}
		span:nth-child(4) {
			animation: fadeIn 2s linear 8s forwards, fadeOut 3s linear 28s forwards;
		}
		span:nth-child(5) {
			animation: fadeIn 2s linear 9s forwards, fadeOut 3s linear 28s forwards;
		}

		span:nth-child(4),
		span:nth-child(5) {
			margin: 0;
			font-size: 80px;
			color: #ffffff73;
			font-weight: 700;
			line-height: 80px;
		}
	}
}
@keyframes fadeIn {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
@keyframes fadeOut {
	0% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
}
</style>
